export const analysticsValueReducer = (
  state = { loadings: false, analystics: [] },
  { type, payload }
) => {
  switch (type) {
    case "SHOW_NUM_ANALYSTICS_LOADING":
      return { ...state, loadings: true };
    case "NUM_ANALYSTICS_DATA":
      return { ...state, analystics: payload, loadings: false };
    case "HIDE_NUM_ANALYSTICS_LOADDED":
      return { ...state, loadings: false };
    default:
      return state;
  }
};

export const transcationAnalysticsReducer = (
  state = { loadings: false, analystics: [] },
  { type, payload }
) => {
  switch (type) {
    case "SHOW_TRANSCATION_ANALYSTICS_LOADING":
      return { ...state, loadings: true };
    case "TRANSCATION_ANALYSTICS_DATA":
      return { ...state, analystics: payload, loadings: false };
    case "HIDE_TRANSCATION_ANALYSTICS_LOADDED":
      return { ...state, loadings: false };
    default:
      return state;
  }
};

export const createAuctionAnalysticsReducer = (
  state = { loadings: false, analystics: [] },
  { type, payload }
) => {
  switch (type) {
    case "SHOW_CREATEAUCTION_ANALYSTICS_LOADING":
      return { ...state, loadings: true };
    case "CREATEAUCTION_ANALYSTICS_DATA":
      return { ...state, analystics: payload, loadings: false };
    case "HIDE_CREATEAUCTION_ANALYSTICS_LOADDED":
      return { ...state, loadings: false };
    default:
      return state;
  }
};
